import Vue from "vue"
import _const from "../../util/my-const";

//定义一个混入对象，混入 (mixin) 提供了一种非常灵活的方式，来分发 Vue 组件中的可复用功能
Vue.mixin({
    methods: {
        isButtonShow(code) {  //返回按钮是否显示状态
            let butList = this.$store.state.buttonList;  //获取按钮集合
            return butList.findIndex(x => x.buttonCode === code) > -1;
        },
        isButtonEnable(code) {  //返回按钮是否禁用状态
            let butList = this.$store.state.buttonList;  //获取按钮集合
            return butList.findIndex(x => x.buttonCode === code && x.enableSign === _const.enableSign.yes) > -1;
        },
        openMessageBox(message) {  //确认取消提示框
            this.confirm(message, "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                console.log("提示框返回true");
                return true;
            }).catch(() => {
                console.log("提示框返回false");
                return false;
            });
        },
    }
})